'use client'

import React, { createContext, use } from 'react'

import type { User } from '@/payload-types'

interface DashboardContextType {
  userData: User | null
  refreshUser: (updatedUser?: User) => Promise<void>
  sidebarOpen: boolean
  setSidebarOpen: (open: boolean) => void
  showXTimeline: boolean
  setShowXTimeline: (show: boolean) => void
  showMyBills: boolean
  setShowMyBills: (show: boolean) => void
  showMyEvents: boolean
  setShowMyEvents: (show: boolean) => void
  showSavedArticles: boolean
  setShowSavedArticles: (show: boolean) => void
  showWinTracker: boolean
  setShowWinTracker: (show: boolean) => void
  /** Update any dashboard group fields; merges with current user.dashboard. */
  updateDashboard: (partial: Partial<NonNullable<User['dashboard']>>) => Promise<void>
}

const DashboardContext = createContext<DashboardContextType | null>(null)

interface DashboardProviderProps {
  children: React.ReactNode
  value: DashboardContextType
}

export const DashboardProvider = ({ children, value }: DashboardProviderProps) => {
  return <DashboardContext.Provider value={value}>{children}</DashboardContext.Provider>
}

export const useDashboard = (): DashboardContextType => {
  const context = use(DashboardContext)
  if (!context) {
    throw new Error('useDashboard must be used within a DashboardProvider')
  }
  return context
}
